module.exports = __webpack_public_path__ + "img/Social_4.39403b3a.webp";